<template>
  <div class="nybanner">
    <img :src="baseApi + 'upload/Banner/classic.jpg'" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/classics/componets/Banner.vue